<template>
  <b-container>
    <b-card no-body>
      <b-tabs card>
        <b-tab :title="$t('globals.other')">
          <b-row>
            <b-col>
              <h5 class="text-secondary float-right">
                {{ $t("globals.inquiries") }}:
              </h5>
            </b-col>
            <b-col>
              <div
                v-b-tooltip.hover
                placement="topleft"
                title="(completed / lost / pending / ratio)"
              >
                <icon
                  v-if="loading.inquiries.completed"
                  name="spinner"
                  spin
                ></icon>
                <span v-else class="text-success">{{
                  inquiries.completed
                }}</span>
                <span> / </span>
                <icon v-if="loading.inquiries.lost" name="spinner" spin></icon>
                <span v-else class="text-danger">{{ inquiries.lost }}</span>
                <span> / </span>
                <icon
                  v-if="loading.inquiries.pending"
                  name="spinner"
                  spin
                ></icon>
                <span v-else class="text-warning">{{ inquiries.pending }}</span>
                <span> / </span>
                <icon v-if="loading.inquiries.ratio" name="spinner" spin></icon>
                <span v-else class="text-info">{{ inquiries.ratio }}</span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5 class="text-secondary float-right">
                {{ $t("globals.orders") }}:
              </h5>
            </b-col>
            <b-col>
              <div
                v-b-tooltip.hover
                title="(completed / terminated / canceled / avg. dur)"
              >
                <icon
                  v-if="loading.orders.completed"
                  name="spinner"
                  spin
                ></icon>
                <span v-else class="text-success">{{ orders.completed }}</span>
                <span> / </span>
                <icon
                  v-if="loading.orders.terminated"
                  name="spinner"
                  spin
                ></icon>
                <span v-else class="text-danger">{{ orders.terminated }}</span>
                <span> / </span>
                <icon v-if="loading.orders.canceled" name="spinner" spin></icon>
                <span v-else class="text-warning">{{ orders.canceled }}</span>
                <span> / </span>
                <icon
                  v-if="loading.orders.avg_duration"
                  name="spinner"
                  spin
                ></icon>
                <span v-else class="text-info">{{ orders.avg_duration }}</span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5 class="text-secondary float-right">
                {{ $t("globals.devices") }}:
              </h5>
            </b-col>
            <b-col>
              <!-- "(active / terminated / warranty / canceled)" -->
              <div v-b-tooltip.hover title="(active / warranty)">
                <icon v-if="loading.devices.active" name="spinner" spin></icon>
                <span v-else class="text-success">{{ devices.active }}</span>
                <span> / </span>
                <!--
                <icon v-if="loading.devices.terminated" name="spinner" spin></icon>
                <span v-else class="text-danger" >{{ devices.terminated }}</span>
                <span> / </span>
                -->
                <icon
                  v-if="loading.devices.warranty"
                  name="spinner"
                  spin
                ></icon>
                <span v-else class="text-info">{{ devices.warranty }}</span>
                <!--
                <span> / </span>
                <icon v-if="loading.devices.canceled" name="spinner" spin></icon>
                <span v-else class="text-warning" >{{ devices.canceled }}</span>
                -->
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5 class="text-secondary float-right">
                {{ $t("globals.invoices") }}:
              </h5>
            </b-col>
            <b-col>
              <div v-b-tooltip.hover title="(created / scheduled)">
                <icon
                  v-if="loading.invoices.created"
                  name="spinner"
                  spin
                ></icon>
                <span v-else class="text-success">{{ invoices.created }}</span>
                <span> / </span>
                <icon
                  v-if="loading.invoices.scheduled"
                  name="spinner"
                  spin
                ></icon>
                <span v-else class="text-info">{{ invoices.scheduled }}</span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5 class="text-secondary float-right">
                {{ $t("globals.customers") }}:
              </h5>
            </b-col>
            <b-col>
              <div v-b-tooltip.hover title="(all)">
                <icon v-if="loading.customers.all" name="spinner" spin></icon>
                <span v-else class="text-success">{{ customers.all }}</span>
              </div>
            </b-col>
          </b-row>
        </b-tab>
        <b-nav-item slot="tabs" @click.prevent="fetchData">
          <icon name="sync-alt" :spin="isLoading"></icon>
        </b-nav-item>
      </b-tabs>
    </b-card>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import "vue-awesome/icons/spinner";
import "vue-awesome/icons/sync-alt";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue")
  },
  data() {
    return {
      range: [null, null],
      inquiries: {
        completed: 0,
        lost: 0,
        pending: 0,
        ratio: 0
      },
      orders: {
        completed: 0,
        canceled: 0,
        terminated: 0,
        avg_duration: 0
      },
      devices: {
        active: 0,
        terminated: 0,
        warranty: 0,
        canceled: 0
      },
      invoices: {
        created: 0,
        scheduled: 0
      },
      customers: {
        all: 0
      },
      loading: {
        inquiries: {
          completed: false,
          lost: false,
          pending: false,
          ratio: false
        },
        orders: {
          completed: false,
          canceled: false,
          teminated: false,
          avg_duration: false
        },
        devices: {
          active: false,
          terminated: false,
          warranty: false,
          canceled: false
        },
        invoices: {
          created: false,
          scheduled: false
        },
        customers: {
          all: false
        }
      }
    };
  },
  methods: {
    ...mapActions([
      "fetchNoInquiries",
      "fetchInquiryOrderRatio",
      "fetchNoOrders",
      "fetchNoDevices",
      "fetchNoInvoices",
      "fetchNoScheduledInvoices",
      "fetchOrderDurationAvg",
      "fetchCustomersCreatedForRange",
      "fetchNoCanceledDevices",
      "fetchNoTerminatedDevices"
    ]),
    fetchNumberOfInquiries() {
      this.loading.inquiries.completed = true;
      this.loading.inquiries.lost = true;
      this.loading.inquiries.pending = true;

      this.fetchNoInquiries({ range: this.range, status: "completed" })
        .then(res => {
          this.inquiries.completed = res.data.data.noInquiriesForStatus;
        })
        .finally(() => {
          this.loading.inquiries.completed = false;
        });

      this.fetchNoInquiries({ range: this.range, status: "lost" })
        .then(res => {
          this.inquiries.lost = res.data.data.noInquiriesForStatus;
        })
        .finally(() => {
          this.loading.inquiries.lost = false;
        });

      this.fetchNoInquiries({ range: this.range, status: "pending" })
        .then(res => {
          this.inquiries.pending = res.data.data.noInquiriesForStatus;
        })
        .finally(() => {
          this.loading.inquiries.pending = false;
        });
    },
    fetchRatio() {
      this.loading.inquiries.ratio = true;

      this.fetchInquiryOrderRatio(this.range)
        .then(res => {
          this.inquiries.ratio = res.data.data.inquiriesOrderRatio;
        })
        .finally(() => {
          this.loading.inquiries.ratio = false;
        });
    },
    fetchNumberOfOrders() {
      this.loading.orders.completed = true;
      this.loading.orders.canceled = true;
      this.loading.orders.terminated = true;
      this.loading.orders.avg_duration = true;

      this.fetchNoOrders({ range: this.range, status: "completed" })
        .then(res => {
          this.orders.completed = res.data.data.noOrdersForStatus;
        })
        .finally(() => {
          this.loading.orders.completed = false;
        });

      this.fetchNoOrders({ range: this.range, status: "canceled" })
        .then(res => {
          this.orders.canceled = res.data.data.noOrdersForStatus;
        })
        .finally(() => {
          this.loading.orders.canceled = false;
        });

      this.fetchNoOrders({ range: this.range, status: "terminated" })
        .then(res => {
          this.orders.terminated = res.data.data.noOrdersForStatus;
        })
        .finally(() => {
          this.loading.orders.terminated = false;
        });

      this.fetchOrderDurationAvg({ range: this.range })
        .then(res => {
          this.orders.avg_duration = res.data.data.avgContractLength;
        })
        .finally(() => {
          this.loading.orders.avg_duration = false;
        });
    },
    fetchNumberOfDevices() {
      this.loading.devices.active = true;
      this.loading.devices.terminated = true;
      this.loading.devices.warranty = true;
      this.loading.devices.canceled = true;

      this.fetchNoDevices({ range: this.range, status: "active" })
        .then(res => {
          this.devices.active = res.data.data.noDevicesForStatus;
        })
        .finally(() => {
          this.loading.devices.active = false;
        });

      this.fetchNoTerminatedDevices({ range: this.range })
        .then(res => {
          this.devices.terminated = res.data.data.terminatedDevices;
        })
        .finally(() => {
          this.loading.devices.terminated = false;
        });

      this.fetchNoDevices({ range: this.range, status: "warranty" })
        .then(res => {
          this.devices.warranty = res.data.data.noDevicesForStatus;
        })
        .finally(() => {
          this.loading.devices.warranty = false;
        });

      this.fetchNoCanceledDevices({ range: this.range })
        .then(res => {
          this.devices.canceled = res.data.data.canceledDevices;
        })
        .finally(() => {
          this.loading.devices.canceled = false;
        });
    },
    fetchNumberOfInvoices() {
      this.loading.invoices.created = true;
      this.loading.invoices.scheduled = true;

      this.fetchNoInvoices({ range: this.range })
        .then(res => {
          this.invoices.created = res.data.data.noInvoices;
        })
        .finally(() => {
          this.loading.invoices.created = false;
        });

      this.fetchNoScheduledInvoices({ range: this.range, status: "scheduled" })
        .then(res => {
          this.invoices.scheduled = res.data.data.noScheduledInvoices;
        })
        .finally(() => {
          this.loading.invoices.scheduled = false;
        });
    },
    fetchCustomers() {
      this.loading.customers.all = true;

      this.fetchCustomersCreatedForRange({ range: this.range })
        .then(res => {
          this.customers.all = res.data.data.noCustomersForRange;
        })
        .finally(() => {
          this.loading.customers.all = false;
        });
    },
    fetchData() {
      this.fetchNumberOfInquiries();
      this.fetchNumberOfOrders();
      this.fetchNumberOfDevices();
      this.fetchNumberOfInvoices();
      this.fetchCustomers();
      this.fetchRatio();
    }
  },
  computed: {
    ...mapGetters(["getUserSystem"]),
    isLoading() {
      return (
        this.loading.orders.completed &&
        this.loading.inquiries.completed &&
        this.loading.inquiries.lost &&
        this.loading.inquiries.pending &&
        this.loading.inquiries.ratio &&
        this.loading.devices.active &&
        this.loading.devices.terminated &&
        this.loading.devices.warranty &&
        this.loading.invoices.created &&
        this.loading.customers.all &&
        this.loading.invoices.scheduled
      );
    }
  },
  watch: {
    getUserSystem: function() {
      this.fetchData();
    },
    range: function() {
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>
